import type { StrategicGuide } from "@/types/types";

export const getPlannedRetirementYear = (retirementAge: number, birthDate: string | undefined) => {
  if (!birthDate || !retirementAge) return undefined;

  const date = new Date(
    new Date().setFullYear(new Date(birthDate ?? "").getFullYear() + retirementAge)
  ).getFullYear();

  return date;
};

export const getAnnualReviews = (sg: StrategicGuide | undefined) => {
  const arr = [];

  const reviewTypes = [
    {
      type: "Comprehensive AO Investment Review",
      lastProp: "lastComprehensiveAOInvestmentReview",
      nextProp: "nextComprehensiveAOInvestmentReview",
    },
    { type: "Tax Analysis", lastProp: "lastTaxAnalysisReview", nextProp: "nextTaxAnalysisReview" },
    { type: "UP", lastProp: "lastUPReview", nextProp: "nextUPReview" },
    { type: "NPV", lastProp: "lastNPVReview", nextProp: "nextNPVReview" },
    { type: "AB", lastProp: "lastABReview", nextProp: "nextABReview" },
    { type: "FAB", lastProp: "lastFABReview", nextProp: "nextFABReview" },
    {
      type: "Estate Planning Matrix Review",
      lastProp: "lastEstatePlanningMatrixReview",
      nextProp: "nextEstatePlanningMatrixReview",
    },
    {
      type: "Survivorship",
      lastProp: "lastSurvivorshipReview",
      nextProp: "nextSurvivorshipReview",
    },
  ];

  for (const { type, lastProp, nextProp } of reviewTypes) {
    if (sg?.[lastProp] && sg?.[nextProp]) {
      arr.push({
        type,
        lastReview: sg[lastProp],
        nextReview: sg[nextProp],
      });
    }
  }

  return arr;
};

export const getShortfall = (sg: StrategicGuide | undefined, abFixedIncome: number | undefined) => {
  const shortfall =
    (abFixedIncome ?? 0) -
    (sg?.totalAOCashEquivalents ?? 0) -
    (sg?.aoFixedIncome ?? 0) -
    (sg?.nonAOFixedIncome ?? 0) -
    (sg?.totalNonAOCashEquivalents ?? 0) +
    (sg?.targetCash ?? 0) +
    (sg?.specialReserves ?? 0);

  if (shortfall < 0) return 0;
  return shortfall;
};
